function confirm_visits() {
    const $ = jQuery.noConflict();
    if ($('.save-button-wrapper').hasClass('hidden')) {
        $('.add-button-wrapper a').trigger('click');
        return false;
    }
    const data = $('form.planning-board-wrapper').serializeJSON();
    $.squdeAjaxPopup({
        url: '/schedule/confirm',
        data: data,
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                squde_reload_for_flashes();
                $('.planning-board-grid-wrapper').resetBoard();
                $('.planning-board-grid-wrapper').trigger('reload');
            });
        }
    });
    return false;
}
function cancel_visit(visit_id, callback = function() {}) {
    const $ = jQuery.noConflict();
    custom_delete_with_confirmation('/board/cancelVisit/' + visit_id, visit_id, 'Weet u zeker dat u deze planning wilt annuleren?', 'Visit', function() {
        squde_reload_for_flashes();
        callback();
    });
}
